window.app = window.app || {};

window.app.lpProducts = {
  el: {
    section: document.querySelector('.mt-lp-products'),
    thumbs: document.querySelector('.mt-product-thumbs .swiper'),
    thumbItems: document.querySelectorAll('.mt-product-thumbs .swiper-slide'),
    thumbButtons: document.querySelectorAll('.mt-product-thumbs__button'),
    mainGallery: document.querySelector('.mt-product-gallery .swiper'),
    summary: document.querySelector('.mt-lp-form__summary'),
    summaryPrices: document.querySelector('.mt-lp-form__summary-prices'),
    accordions: document.querySelectorAll('.mt-lp-products__details .mt-accordion'),
    form: document.querySelector('#mt-lp-product-form'),
    formFieldIds: document.querySelectorAll('#mt-lp-product-form input[name="id"]'),
    formSelectedProduct: document.querySelector('#mt-lp-product-form input[name="id"]:checked'),
    formOptions: document.querySelectorAll('#mt-lp-product-form .mt-lp-form__product-variants input'),
    formSubmit: document.querySelector('#mt-lp-product-form .mt-lp-form__summary .mt-btn'),
    footer: document.querySelector('.mt-footer-lp')
  },
  breakpoint: 'mobile',
  slider: {},

  updateAccordions: function (force = false) {
    const _this = this;
    const newBreakpoint = (window.innerWidth >= 992) ? 'desktop' : 'mobile';
    let isDefaultVisible = false;

    if (newBreakpoint === _this.breakpoint && !force) return;
    _this.el.accordions.forEach(ac => {
      if (window.innerWidth >= 992) {
        ac.setAttribute('open', '');
      } else {
        ac.removeAttribute('open');
        if (!isDefaultVisible) {
          ac.setAttribute('open', '')
          isDefaultVisible = true;
        }
      }
    });
    _this.breakpoint = newBreakpoint;
  },

  updateGallery: function () {
    const _this = this;

    // Product gallery
    if (_this.el.thumbs) {
      _this.slider.thumbs = new Swiper(_this.el.thumbs, {
        direction: 'vertical',
        slidesPerView: 4,
        spaceBetween: 8,
        height: 440,
        navigation: {
          nextEl: '.mt-product-thumbs__button--next',
          prevEl: '.mt-product-thumbs__button--prev',
        }
      });
    }

    if (_this.el.mainGallery) {
      _this.slider.main = new Swiper(_this.el.mainGallery, {
        spaceBetween: 0,
        thumbs: {
          swiper: _this.slider.thumbs
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        breakpoints: {
          450: {
            spaceBetween: -5,
          },
          768: {
            spaceBetween: 5,
          }
        }
      });
    }

    if (_this.el.thumbItems.length > 0) {
      _this.el.thumbItems.forEach(thumb => {
        const index = Number(thumb.dataset.slide);
        thumb.addEventListener('mouseenter', () => _this.slider.main.slideTo(index, 0));
      });
    }

    if (_this.el.thumbButtons.length > 0) {
      _this.el.thumbButtons.forEach(button => {
        button.addEventListener('click', e => {
          e.preventDefault();
          (button.classList.contains('mt-product-thumbs__button--prev')) ? _this.slider.thumbs.slidePrev() : _this.slider.thumbs.slideNext();
        });
      });
    }
  },

  updateView: function (variantId = null) {
    const _this = this;
    const product = window.lpProducts.find(p => p.variant_id == variantId);

    if (variantId === null || !product) return;

    // Prices
    if (_this.el.summaryPrices) {
      const price = Shopify.formatMoney(product.price, window.Shopify.money_format).replace('.00', '');
      const compareAtPrice = (product.compare_at_price !== undefined && product.compare_at_price > product.price) ? Shopify.formatMoney(product.compare_at_price, window.Shopify.money_format).replace('.00', '') : null;
      let pricesHtml = '';
      if (compareAtPrice !== null) {
        pricesHtml = `<s class="mt-price mt-price--old">${compareAtPrice}</s><span class="mt-price mt-price--sale">${price}</span>`;
      } else {
        pricesHtml = `<span class="mt-price">${price}</span>`;
      }
      _this.el.summaryPrices.innerHTML = pricesHtml;
    }

    // Accordions
    _this.el.accordions.forEach(accordion => {
      const content = accordion.querySelector('.mt-accordion__content-inner');
      (accordion.dataset.type === 'description') && (content.innerHTML = product.description);
      (accordion.dataset.type === 'whats-inside') && (content.innerHTML = product.whats_inside);
    });

    // Gallery
    const mainWrapper = _this.el.mainGallery.querySelector('.swiper-wrapper');
    const thumbsWrapper = _this.el.thumbs.querySelector('.swiper-wrapper');
    _this.slider.main && _this.slider.main.destroy(true, true);
    _this.slider.thumbs && _this.slider.thumbs.destroy(true, true);

    if (mainWrapper) {
      mainWrapper.innerHTML = '';
      product.images?.forEach((image, i) => {
        mainWrapper.innerHTML += `<div class="swiper-slide" data-slide="${i}"><div class="mt-product-gallery__item"><img src="${image}" alt="${product.title}"></div></div>`;
      });
    }
    if (thumbsWrapper) {
      thumbsWrapper.innerHTML = '';
      product.images?.forEach((image, i) => {
        thumbsWrapper.innerHTML += `<div class="swiper-slide" data-slide="${i}"><div class="mt-product-thumbs__item" data-type="image"><img src="${image}" alt="${product.title}"></div></div>`;
      });
    }
    _this.updateGallery();
  },

  salesForm: function() {
    window.addEventListener('DOMContentLoaded', () => {
      const salesFormLinks = document.querySelectorAll('a[href="#contact-form"]');
      const salesFormBtn = document.querySelector('.mt-contact-categories__item .mt-btn');
  
      if (salesFormLinks.length > 0 && salesFormBtn) {
        salesFormLinks.forEach(link => {
          link.addEventListener('click', e => {
            e.preventDefault();
            e.stopPropagation();
            salesFormBtn.click();
          });
        });
      }
    });
  },

  sizeGuide: {
    el: {
      switcher: document.querySelector('.mt-modal--size-guide .mt-switcher'),
      table: document.querySelector('.mt-size-guide__table table')
    },

    reCalculate: function(unit = null) {
      const { el } = this;
      if (!el.switcher || !el.table) return;
      (unit === null) && (unit = el.switcher.dataset.active);

      const cells = el.table.querySelectorAll('td');
      cells.forEach(cell => {
        const values = { cm: cell.dataset.cm, inch: cell.dataset.inch };
        if (!values.cm || !values.inch) return;
        cell.innerText = values[unit];
      });
    },

    init: function() {
      const _this = this;
      if (!_this.el.switcher) return;

      _this.el.switcher.addEventListener('click', e => {
        const currentUnit = _this.el.switcher.dataset.active;
        let newUnit = currentUnit;

        if (e.target.classList.contains('mt-switcher__toggle')) {
          newUnit = (currentUnit == 'cm') ? 'inch' : 'cm';
        } else if (e.target.classList.contains('mt-switcher__option')) {
          newUnit = e.target.dataset.option;
        }

        if (currentUnit !== newUnit) {
          _this.el.switcher.dataset.active = newUnit;
          _this.reCalculate(newUnit);
        }
      });
    }
  },

  stickySummary: function() {
    const _this = this;
    _this.el.footer = document.querySelector('.mt-footer-lp');
    const footerObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        _this.el.summary.classList.toggle('hidden', entry.isIntersecting);
      });    
    });
    _this.el.footer && footerObserver.observe(_this.el.footer);
  },

  init: function () {
    const _this = this;
    if (!_this.el.section) return;

    // Gallery
    _this.updateGallery();

    // Accordions
    if (_this.el.accordions.length > 0) {
      _this.el.accordions.forEach(accordion => {
        const summary = accordion.querySelector('summary');
        summary.addEventListener('click', e => {
          e.preventDefault();
          if (window.innerWidth >= 992) return;
          _this.el.accordions.forEach(acc => acc !== accordion && acc.removeAttribute('open'));
          accordion.toggleAttribute('open');
        });
      });
      _this.updateAccordions();
      window.addEventListener('resize', () => {
        _this.updateAccordions();
      });
    }

    // Form
    _this.el.form.addEventListener('submit', e => e.preventDefault());
    _this.el.formFieldIds.forEach(formFieldId => {
      formFieldId.addEventListener('change', () => {
        const selectedProduct = _this.el.form.querySelector('input[name="id"]:checked');
        _this.updateView(selectedProduct.value);
      });
    });
    _this.el.formOptions.forEach(option => {
      option.addEventListener('change', () => {
        const productId = _this.el.formSelectedProduct.dataset.pid;
        const productJson = JSON.parse(_this.el.formSelectedProduct.dataset.product);
        const product = window.lpProducts.find(p => p.id === productId);
        
        if (product) {
          const variant = product.variants.find(v => v.title === option.value);
          if (!variant) return;
  
          // Update product data
          product.variant_id = variant.id;
          product.price = variant.price;
          product.compare_at_price = variant.compare_at_price;
          productJson.variant = variant.title;
          productJson.variant_id = variant.id;
          productJson.sku = variant.sku;
          _this.el.formSelectedProduct.value = variant.id;
          _this.el.formSelectedProduct.dataset.product = JSON.stringify(productJson);
        }
      });
    });

    // Sales form
    _this.salesForm();

    // Size guide (for hoodies)
    document.addEventListener('DOMContentLoaded', () => _this.sizeGuide.init());

    // Events
    const viewItemWhenAvailable = () => {
      const viwaId = setInterval(() => {
        if (window.app && window.app.dl && typeof window.app.dl.viewItem === 'function') {
          clearInterval(viwaId);
          window.app.dl.viewItem(_this.el.formSelectedProduct.dataset.product);
        }
      }, 100);
    };
    viewItemWhenAvailable();
  }
}
window.app.lpProducts.init();
document.addEventListener('DOMContentLoaded', () => window.app.lpProducts.stickySummary());